<template lang="pug">
.tabela-selecionar-territorio-monitoramento.view-container
    h3 {{ $t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.titulo') }}
    el-table(
        ref='multiplaSelecao',
        :data='dadosTabelaMonitoramento.itens',
        stripe,
        style='width: 100%',
        @selection-change='handleSelecionarRows'
    )
        el-table-column(type='selection', width='55')

        el-table-column(prop='nome', :label="$t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.territorio')", min-width='200px')
            template(slot-scope='scope')
                span {{ scope.row.nome }}

        el-table-column(
            v-if="verificaUsuarioNorteAmerica"
            :formatter='formatAreaAcTableColumn',
            prop='areaHa',
            min-width='150px',
            :label="$t('mensagens.diagnosticoSocioambiental.areaAc')"
        )
        el-table-column(
            v-else
            :formatter='formatAreaHaTableColumn',
            prop='areaHa',
            min-width='150px',
            :label="$t('mensagens.diagnosticoSocioambiental.areaHa')"
        )

        el-table-column(:label="$t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.localidade')", prop='localidade', min-width='200px')
            template(slot-scope='scope')
                p {{ scope.row.localidade }}

        el-table-column(:label="$t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.idPessoa')", prop='idCliente', v-if='!verificaUsuarioParaguai')
            template(slot-scope='scope')
                .representante(
                    v-if='scope.row.pessoas && scope.row.pessoas.length > 0 && scope.row.pessoas[0].idCliente'
                )
                    p {{ scope.row.pessoas[0].idCliente }}
                .representante(v-else)
                    p -

        el-table-column(
            :label="$t(verificaUsuarioParaguai ? 'mensagens.comuns.produtores' : 'mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.pessoa')",
            prop='pessoas',
            min-width='200px'
        )
            template(slot-scope='scope')
                .representante(
                    v-if='scope.row.pessoas && scope.row.pessoas.length > 0'
                )
                    p {{ scope.row.pessoas[0].nomeRazaoSocial }}
                        span ({{ formatCpfCnpj(scope.row.pessoas[0].documento || scope.row.pessoas[0].cpfCnpj, scope.row.pessoas[0].tipoDocumento) }})
                        el-popover(
                            placement='bottom',
                            popper-class='el-popper-in-table',
                            trigger='hover'
                        )
                            el-tag.ml-2(
                                v-if='scope.row.pessoas.length > 1',
                                size='mini',
                                slot='reference'
                            ) {{ scope.row.pessoas.length - 1 }}
                            div(
                                v-for='(representante, index) in scope.row.pessoas',
                                :key='index'
                            ) {{ representante.nomeRazaoSocial }}
                                span ({{ formatCpfCnpj(representante.documento || representante.cpfCnpj, representante.tipoDocumento) }})
                .representante(v-else)
                    p -

        el-table-column(prop='codigo', label='CAR', min-width='300px', v-if='!verificaUsuarioParaguai && !verificaUsuarioNorteAmerica')
            template(slot-scope='scope')
                .car(v-if='scope.row.cars && scope.row.cars.length > 0')
                    p.car-hiden-row {{ scope.row.cars[0].codigo }}
                        el-popover(
                            placement='bottom',
                            popper-class='el-popper-in-table',
                            trigger='hover'
                        )
                            el-tag.ml-2(
                                v-if='scope.row.cars.length > 1',
                                size='mini',
                                slot='reference'
                            ) {{ scope.row.cars.length - 1 }}

                            div(
                                v-for='(car, index) in scope.row.car',
                                :key='index'
                            ) {{ car.codigo }}
                .car(v-else)
                    p -

    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ $t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.rodape', {quantidade_selecionada: rowsSelecionadas.length, quantidade_total: dadosTabelaMonitoramento.totalItens}) }}

        .tabela-rodape--pagination
            el-pagination(
                small,
                layout='prev, pager, next',
                :page-size='paginacao.tamanho',
                :current-page.sync='paginacao.pagina + 1',
                :total='dadosTabelaMonitoramento.totalItens',
                @current-change='mudarPagina'
            )

    ModalCadastrarMonitoramentoAgricola(
        v-if='!verificaUsuarioParaguai'
        :territoriosSelecionados='territoriosSelecionados',
        :show.sync='mostrarModalCadastroAgricola',
        @cadastrarMonitoramentoAgricola='cadastrarMonitoramento'
    )

    ModalCadastrarMonitoramentoAgricolaParaguai(
        v-else
        :territoriosSelecionados='territoriosSelecionados',
        :show.sync='mostrarModalCadastroAgricola',
        @cadastrarMonitoramentoAgricola='cadastrarMonitoramento'
    )
</template>

<script>
import formatters from '@/utils/formatters';
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import ModalCadastrarMonitoramentoAgricola from '@/components/monitoramento/ModalCadastrarMonitoramentoAgricola.vue';
import ModalCadastrarMonitoramentoAgricolaParaguai from '@/components/monitoramento/ModalCadastrarMonitoramentoAgricolaParaguai.vue';
import TipoMonitoramento from '@/constants/TipoMonitoramento.js';

import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
export default {
    name: 'TabelaSelecionarTerritorioMonitoramento',
    components: {
        ModalCadastrarMonitoramentoAgricola,
        ModalCadastrarMonitoramentoAgricolaParaguai
    },
    props: {
        icone: {
            type: String,
            default: () => ''
        },
        texto: {
            type: String,
            default: () => ''
        },
        numero: {
            type: String,
            default: () => ''
        },

        dadosTabelaMonitoramento: {
            type: Object,
            default: () => { }
        },

        tipo: {
            type: String,
            default: () => ''
        },

        paginacao: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            rowsSelecionadas: [],
            territoriosSelecionados: [],
            mostrarModalCadastroAgricola: false,
            ambientes: AmbientesEmpresas
        };
    },

    computed: {
        ...mapState(['usuarioLogado']),
        verificaUsuarioParaguai() {
            if (this.usuarioLogado.paisGrupo === this.ambientes.PARAGUAY) {
                return true;
            }
            return false;
        },
        verificaUsuarioNorteAmerica() {
            return this.usuarioLogado.paisGrupo === this.ambientes.NORTE_AMERICA;
        }
    },

    methods: {
        handleSelecionarRows: function (val) {
            this.rowsSelecionadas = val;

            this.$emit('rows-selecionados-changed', val);
        },

        formatCpfCnpj(cpfCnpj, tipoDocumento) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj, tipoDocumento);
        },

        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },
        formatAreaAcTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa * 2.47105, 2);
        },

        mudarPagina(pagina) {
            this.$emit('atualizar-pagina', pagina);
        },

        visualizarTerritorio: function (row) {
            this.$router.push({ name: 'DadosTerritorio' });
        },

        iniciarMonitoramento() {
            const areasMonitoramento = [];
            this.rowsSelecionadas.forEach(r => {
                areasMonitoramento.push({
                    ...r,
                    idTerritorio: r.id,
                    tipoMonitoramento: this.tipo
                });
            });

            if (this.tipo === TipoMonitoramento.SOCIOAMBIENTAL) {
                this.cadastrarMonitoramento(areasMonitoramento, _);
            } else if (this.tipo === TipoMonitoramento.AGRICOLA) {
                this.mostrarModalCadastroAgricola = true;
                this.territoriosSelecionados = areasMonitoramento;
            }

            this.$emit('iniciar-monitoramento', areasMonitoramento);
        },
        verificaTerritorioPessoaSemCPF() {
            let territorios = '';
            let pessoasEstrangeiras = 0;
            territorios += this.$t('mensagens.operacao.tabela.territorios') + ':<br/>';
            const areasMonitoramento = [];
            this.rowsSelecionadas.forEach(r => {
                areasMonitoramento.push({
                    ...r,
                    idTerritorio: r.id,
                    tipoMonitoramento: this.tipo
                });
            });
            areasMonitoramento.forEach(area => {
                pessoasEstrangeiras = area.pessoas.filter(pessoa => pessoa.documento.length < 11);
                territorios += ` - ${area.nome}<br/>`;
            });
            return pessoasEstrangeiras > 0 ? territorios : '';
        },
        cadastrarMonitoramento(areasMonitoramento, codigoUnidadeProdutividade) {
            let service = null;

            if (this.tipo === TipoMonitoramento.SOCIOAMBIENTAL) {
                service =
                    MonitoramentoSocioambientalService.enviarAreasMonitoramento(
                        {
                            areasMonitoramento
                        }
                    );
            } else if (this.tipo === TipoMonitoramento.AGRICOLA) {
                service = MonitoramentoAgricolaService.enviarAreasMonitoramento(
                    {
                        areasMonitoramento
                    }
                );
            }

            service
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: this.$t('mensagens.territorio.territorioEnviadoParaMonitoramentoComSucesso')
                        });

                        if (this.tipo === TipoMonitoramento.SOCIOAMBIENTAL) {
                            this.$router.push({ name: 'MonitoramentoSocioambiental' });
                            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INICIAR_MONITORAMENTO_SOCIOAMBIENTAL', pageTitle: 'INICIAR_MONITORAMENTO_SOCIOAMBIENTAL', routeName: this.$route?.name, routePath: this.$route?.path });
                        } else if (this.tipo === TipoMonitoramento.AGRICOLA) {
                            this.$router.push({ name: 'MonitoramentoAgricola' });
                            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INICIAR_MONITORAMENTO_AGRICOLA', pageTitle: 'INICIAR_MONITORAMENTO_AGRICOLA', routeName: this.$route?.name, routePath: this.$route?.path });
                        }
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.ocorreuErroAoEnviarTerritorioParaMonitoramento')
                        });
                    }
                })
                .catch(e => {
                    const errorMessage = e?.response?.data?.message ?? '';
                    let notifyMessage = this.$t('mensagens.territorio.ocorreuErroAoEnviarTerritorioParaMonitoramento');

                    if (errorMessage.includes('ERRO_ENVIAR_AREA_MONITORAMENTO_AGRICOLA') || errorMessage.includes('JA_EXISTE_MONITORAMENTO_AGRICOLA_SAFRA_INFORMADA')) {
                        notifyMessage = this.$t(`mensagens.territorio.${errorMessage}`);
                    }
                    this.$notify.error({
                        message: notifyMessage
                    });
                });

            this.rowsSelecionadas = [];
            this.$refs.multiplaSelecao.clearSelection();
            this.mostrarModalCadastroAgricola = false;
        },

        exportarDados: function (row) { }
    }
};
</script>

<style lang="scss">
.tabela-selecionar-territorio-monitoramento {
    h3 {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .el-table {
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;
    }

    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 47.5% 10px 5px;
        margin-top: 8px;
        border-radius: 6px;
        box-shadow: 0px 3px 5px 0px var(--block-shadow);

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }
}

.button-green {
    border-color: var(--secondary-two);
    color: var(--white);
    background: var(--secondary-two);
}

.button-green.is-disabled {
    color: var(--white);
    background-color: #80a09e;
    border-color: #80a09e;
}

.el-popper-in-table {
    line-height: 1.6;
    max-height: 400px;
    overflow-y: auto;
}

.el-popover__reference-wrapper {
    cursor: pointer;
}

.tabela-rodape--esquerda p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
